export default {"src":"/_next/static/media/advantages-icon-7.4dbcd76a.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};